import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("admin_token", data.access_token);
      toast.success("Welcome back, Mr. Aggarwal");
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ background: "var(--cream)", minHeight: "100vh" }}>
      <div className="min-h-screen grid grid-cols-1 md:grid-cols-2">
        {/* Left — editorial */}
        <div
          className="p-10 md:p-16 flex flex-col justify-between"
          style={{ background: "var(--ink)", color: "var(--cream)" }}
        >
          <div className="mono-eyebrow" style={{ color: "#a3a3a3" }}>§ Practitioner Access</div>
          <div>
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9 }}
              className="serif text-5xl md:text-7xl leading-[0.98]"
              style={{ letterSpacing: "-0.03em" }}
            >
              A private<br />door,<br />for the counsellor.
            </motion.h1>
            <p className="mt-8 max-w-[440px]" style={{ color: "#a3a3a3" }}>
              A quiet room where Mr. Aggarwal reviews the day's letters and appointments.
            </p>
          </div>
          <div />
        </div>

        {/* Right — form */}
        <div className="p-10 md:p-20 flex items-center">
          <motion.form
            onSubmit={submit}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="w-full max-w-md"
          >
            <div className="mono-eyebrow mb-3">Sign in</div>
            <h2 className="serif text-4xl md:text-5xl" style={{ letterSpacing: "-0.02em" }}>Welcome back.</h2>

            <div className="mt-10 space-y-6">
              <div>
                <label className="mono-eyebrow">Email</label>
                <input
                  data-testid={ADMIN.emailInput}
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="pritam@counsel.in"
                  className="mt-2 w-full p-4 border hairline bg-white focus:outline-none focus:border-black"
                  style={{ borderRadius: 2 }}
                />
              </div>
              <div>
                <label className="mono-eyebrow">Password</label>
                <input
                  data-testid={ADMIN.passwordInput}
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-2 w-full p-4 border hairline bg-white focus:outline-none focus:border-black"
                  style={{ borderRadius: 2 }}
                />
              </div>
            </div>

            <button
              type="submit"
              data-testid={ADMIN.loginBtn}
              disabled={loading}
              className="btn-terra mt-10 w-full justify-center"
            >
              {loading ? <Loader2 size={16} className="animate-spin" /> : <ArrowRight size={16} strokeWidth={1.5} />}
              {loading ? "Signing in…" : "Enter"}
            </button>
          </motion.form>
        </div>
      </div>
    </div>
  );
}
